import styled from 'styled-components';

const CustomColorPickerContainer = styled.div`
    user-select: none;
    width: ${({ pickerWidth }) => (pickerWidth ? `${pickerWidth}px` : 'auto')};
`;

export default CustomColorPickerContainer;
